export default "__VITE_ASSET__CZiQNN$1__"